import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle, { AppModalTitleProps } from "@/common/components/Modals/AppModalTitle";

import { PersonalDataDelete, PersonalDataDeleteProps } from "./PersonalDataDelete";

interface Props extends AppModalProps {
  subProps: PersonalDataDeleteProps;
  modelTitleProps?: Partial<AppModalTitleProps>;
}

export function PersonalDataDeleteModal({ subProps, modelTitleProps, ...modalProps }: Props) {
  return (
    <AppModal fullWidth maxWidth='md' {...modalProps}>
      <AppModalTitle
        title='Delete personal data'
        withClose
        onClose={() => modalProps.onClose?.({}, "escapeKeyDown")}
        {...modelTitleProps}
      />

      <AppModalContent>
        <PersonalDataDelete
          {...subProps}
          onCancel={() => {
            modalProps.onClose?.({}, "escapeKeyDown");
            subProps.onCancel?.();
          }}
        />
      </AppModalContent>
    </AppModal>
  );
}
